<div class="modal-header">
  <h4 class="modal-title">New Project</h4>

  <button
    type="button"
    aria-label="Close"
    [disabled]="step === Steps.GeneratingScript"
    (click)="activeModal.dismiss()"
    class="btn-close"></button>
</div>
<div class="modal-body">
  @switch (step) {
    @case (Steps.Input) {
      <app-input-form></app-input-form>
    }
    @case (Steps.Outline) {
      <app-outline-form [params]="outlineParams"></app-outline-form>
    }
    @case (Steps.GeneratingScript) {
      <div class="d-flex justify-content-center align-items-center gap-2">
        <div class="spinner-grow text-primary" role="status"></div>
        <div>Generating (might take 3-5 minutes)...</div>
      </div>
    }
  }
</div>
<div class="modal-footer">
  @if (serverError) {
    <div class="text-danger me-auto">
      Something went wrong. Please try change input data or try later.
    </div>
  }
  <button class="btn btn-secondary" (click)="activeModal.dismiss()">
    Cancel
  </button>
  <!-- @switch (step) {
    @case (Steps.Input) {
      <button
        class="btn btn-secondary"
        [disabled]="
          !inputForm || inputForm.form.invalid || inputForm.isBrainstorming
        "
        (click)="goToOutlineStep()">
        Go to outline
      </button>
    }
  } -->
  <button
    class="btn btn-primary"
    [disabled]="step === Steps.GeneratingScript"
    (click)="goToScript()">
    Generate
  </button>
</div>
